import { render, staticRenderFns } from "./DealPromoters.vue?vue&type=template&id=21fb2563&scoped=true&"
import script from "./DealPromoters.vue?vue&type=script&lang=js&"
export * from "./DealPromoters.vue?vue&type=script&lang=js&"
import style0 from "./DealPromoters.vue?vue&type=style&index=0&id=21fb2563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb2563",
  null
  
)

export default component.exports